import { createContext, useContext, useState } from 'react';

type DraftType = {
  status: 'pending' | 'success' | 'error';
  data?: any;
};

type DraftResponseContextType = {
  draftResponse: DraftType | null;
  setDraftResponse: (response: DraftType | null) => void;
};

const DraftResponseContext = createContext<
  DraftResponseContextType | undefined
>(undefined);

export const useDraftResponse = (): DraftResponseContextType | undefined => {
  return useContext(DraftResponseContext);
};

export const DraftResponseProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const [draftResponse, setDraftResponse] = useState<DraftType | null>(null);

  return (
    <DraftResponseContext.Provider value={{ draftResponse, setDraftResponse }}>
      {children}
    </DraftResponseContext.Provider>
  );
};
